import React, { FC, useEffect, useCallback } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import { connect } from 'react-redux';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { useBackgroundColor } from '@v2/pages/machines/hooks/useBackgroundColor';
import { clearState } from '@reducers/imageHandling';
import { useFocusEffect } from '@react-navigation/native';

interface PartDocumentsProps extends NavigationProps {
  partId: number | null;
  clearState: () => void;
}

const PartDocumentsComponent: FC<PartDocumentsProps> = ({ lg, partId, clearState }) => {
  const { machineScreenMainBg } = useBackgroundColor();

  // Clear state when screen is focused and partId is null
  useFocusEffect(
    useCallback(() => {
      if (partId == null) {
        clearState();
      }
    }, [partId, clearState])
  );

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      {partId != null && (
        <View style={[MACHINES_PAGES_CONTAINER_STYLES, {paddingHorizontal: 0}]}>
          <ImagesDocumentsContent
            documentRetrieveId={partId}
            documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part}
            bigSliderBg={machineScreenMainBg}
            smallSliderBg={machineScreenMainBg}
          />
        </View>
      )}
    </MachinesProvider>
  );
};

const PartDocuments = connect(
  ({ details: { partId } }) => ({ partId }),
  { clearState }
)(PartDocumentsComponent);

export { PartDocuments };
